// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"766":"17c675fe","865":"198c8ace"}[chunkId] + ".chunk.css";
};